var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSimpleArrowLeft = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 8.48 14.14",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.48 12.73 2.83 7.07l5.65-5.65L7.07 0 0 7.07l7.07 7.07z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSimpleArrowLeft);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/simple-arrow-left.16c6ea7047e011db2e64d6e380b85543.svg";